export const rsvpConstants = {
  UPDATE_ATTENDANCE_REQUEST: 'RSVP/UPDATE_ATTENDANCE_REQUEST',
  UPDATE_ATTENDANCE_SUCCESS: 'RSVP/UPDATE_ATTENDANCE_SUCCESS',
  UPDATE_ATTENDANCE_FAILURE: 'RSVP/UPDATE_ATTENDANCE_FAILURE',

  REJECT_INVITATION_REQUEST: 'RSVP/REJECT_INVITATION_REQUEST',
  REJECT_INVITATION_SUCCESS: 'RSVP/REJECT_INVITATION_SUCCESS',
  REJECT_INVITATION_FAILURE: 'RSVP/REJECT_INVITATION_FAILURE',

  CLEAR_DATA: 'RSVP/CLEAR_DATA'
}
